/**
 * Mobile select-size bar.
 *
 * Shows a full-bleed bar at the bottom of product pages on mobile from page
 * load. Tapping it scrolls to the variant picker instead of submitting, so a
 * preselected size can never be added by accident. The bar hides while the
 * real buy buttons are on screen, and while the footer is in view.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function init() {
    var bar = document.querySelector('[data-agnst-atc]');
    if (!bar || bar.dataset.agnstBound === 'true') return;

    var trigger = bar.querySelector('[data-agnst-atc-trigger]');
    var buyBlock = document.querySelector('.buy-buttons-block');
    if (!trigger || !buyBlock) return;

    var picker = document.querySelector('variant-picker') || buyBlock;
    var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    var mq = window.matchMedia(MOBILE_QUERY);

    var buyVisible = false;
    var footerVisible = false;

    bar.dataset.agnstBound = 'true';

    function apply() {
      var show = mq.matches && !buyVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
    }

    function headerOffset() {
      var header =
        document.querySelector('.shopify-section-group-header-group') ||
        document.querySelector('header');
      if (!header) return 72;
      var rect = header.getBoundingClientRect();
      var fixed = window.getComputedStyle(header).position;
      if (fixed !== 'sticky' && fixed !== 'fixed') return 16;
      return rect.height + 16;
    }

    function scrollToPicker(event) {
      event.preventDefault();
      var target = picker;
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    trigger.addEventListener('click', scrollToPicker);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        buyVisible = entry.isIntersecting;
        apply();
      }).observe(buyBlock);

      if (footer) {
        new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            if (!entry) return;
            footerVisible = entry.isIntersecting;
            apply();
          },
          { rootMargin: '160px 0px 0px 0px' }
        ).observe(footer);
      }
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(apply);
    }

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
